export const brown = `#f4d785`;
export const brownDark = `#eecc77`;
export const insetShadow = "inset 4px 4px 16px #ed76";
